<div class="card-body top">
	<i class="far fa-plus fa-8x icon"></i>
	<!-- <img [src]="imgUrl" /> -->
</div>
<div class="divider"></div>
<div class="card-body">
	<h5 class="card-text special">Add Integration</h5>
</div>
